import React from 'react';
import { TeamSplitScreen } from './TeamSplitScreen';
export function Team() {
  return <TeamSplitScreen data-id="element-1686" />;
}